import React from "react";
import "./ImageSection.css";
// import about from "../../img/about.png";
import avatar from "../../img/assets/user.jpg";

function ImageSection() {
  return (
    <div className="ImageSection">
      <div className="img">
        <img src={avatar} alt="" />
      </div>
      <div className="about-info">
        <h4>
          I am
          <span> Alabi Timothy</span>
        </h4>
        <p className="about-text">
          A highly motivated, adaptable and responsible individual seeking a
          position in any capacity in which the professional, technical and
          interpersonal skills developed through past experiences will be
          utilized. I have a methodical, customer-focused approach to work and a
          strong drive to see things through to completion.
        </p>
        <div className="about-details">
          <div className="name-details">
            <p> Full Name : </p>
            <p className="p-l">Alabi Timothy</p>
          </div>
          <div className="name-details">
            <p> Nationality : </p>
            <p className="p-l">Nigerian</p>
          </div>
          <div className="name-details">
            <p> Languages : </p>
            <p className="p-l">English, Yoruba</p>
          </div>
        </div>
        <a href="https://halabitimoty-cv.netlify.app/" className="btn">
          Go To Cv
        </a>
      </div>
    </div>
  );
}

export default ImageSection;
